<template>
  <div>
    <div id="reservat" v-if="path == 'reservationList'">
      <header-top haveTab></header-top>
      <el-tabs v-model="activeName" @tab-click="changeStatus">
        <el-tab-pane label="报备管理" name="reservat"></el-tab-pane>
        <el-tab-pane label="退单管理" name="chargeback"></el-tab-pane>
        <el-tab-pane label="历史报备单" name="history"></el-tab-pane>
      </el-tabs>
      <main class="main">
        <reservat v-if="activeName == 'reservat'"></reservat>
        <chargeback v-if="activeName == 'chargeback'"></chargeback>
        <history v-if="activeName == 'history'"></history>
      </main>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import reservat from "./reservat.vue";
import chargeback from "./chargeback.vue";
import history from "./history.vue";

export default {
  components: {
    headerTop,
    reservat,
    chargeback,
    history
  },
  computed: {
    path() {
      return this.$route.name;
    },
  },
  data() {
    return {
      activeName: "reservat",
    };
  },
  mounted() {
    let obj=this.$route.params.obj;
    if (obj) {
        obj=JSON.parse(obj);
        if (obj.flowStatus) {
            this.activeName='history';
        }else{
            this.activeName='chargeback';
        }
    }
  },
  methods: {
    changeStatus(){
      this.$route.params.obj='';
    }
  }
};
</script>
<style scoped lang='scss'>
#reservat {
  .main {
    margin: 20px;
    padding: 20px;
    border-radius: $--border-radius-base;
    background: #fff;
  }
}
</style>
